export default __webpack_public_path__ + "static/media/region-language.24dd1d02.svg";